module.exports = __webpack_public_path__ + "img/arrow-down-full.3bbc78a1.svg";